import { capitalize, map } from 'lodash'
import { ItemPrintableName, ItemPrintableData } from '../apis/ItemPrintable.api'

export default {
  get labels (): ItemPrintableName[] {
    return ['pallet', 'cases']
  },

  get labelChecks () {
    return map(this.labels, label => {
      return {
        name: label,
        label: capitalize(label)
      }
    })
  },

  printableNames (itemPrintables?: ItemPrintableData[]) {
    return map(itemPrintables, itemPrintable => itemPrintable.name)
  }
}
